export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M14 10V8h8v2zm0-6h5v2h-5zm-2 4.5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zM14 20v-2h8v2zm0-6h5v2h-5zm-2 4.5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2z\"/>"
};